<template>
  <div class="partner-page pontofrio-page">
    <PartnersBanner :creditor="creditor" />
    <PartnersHowItWorks :creditor="creditor" />
    <HomeOurChannels
      iconsPath="partners/"
      mobilePath="/images/partners/pontofrio/m-our-channel.png"
      desktopPath="/images/partners/pontofrio/our-channel.png"
      :isPartner="true"
    />
    <PartnersLoggedArea :imageFolder="'partners/' + creditor.alias" />
    <PartnersNeedHelp :creditor="creditor" />
    <HomeOurPartners :partnerName="creditor.name" :isPartner="true" />
  </div>
</template>

<script setup lang="ts">
definePageMeta({
  layout: "creditor",
});

const creditor = ref<CreditorProfile>({
  name: "Ponto Frio",
  alias: "pontofrio",
  id: 2,
  chave: "pontofrio",
});
</script>

<style lang="scss">
@use "@/styles/variables" as v;
@use "@/styles/partners/pontofrio" as pf;

.pontofrio-header {
  .content .creditor-logo {
    max-width: 200px;
    max-height: 25.6px;
    width: 100%;
    height: 100%;
    margin-right: 17px;

    @media screen and (min-width: 834px) {
      max-width: 200px;
      max-height: 26.4px;
    }

    @media screen and (min-width: 834px) and (max-width: 959px) {
      margin-right: 28px;
    }

    @media screen and (min-width: 960px) {
      margin-right: 30px;
    }
  }
}

.pontofrio-page {
  .text-chip {
    background-color: pf.$primaryColor !important;
    color: v.$white !important;
  }

  .title {
    color: v.$greyDark !important;
    font-family: "Open Sans";
    font-weight: 800;
  }

  .partner-banner-section {
    background-image: url(@/assets/images/partners/pontofrio/bg-banner.png);
    background-position: 45% top;
    border-bottom: 10px solid pf.$secondaryColor;

    .wrapper {
      .banner-content {
        .banner-button {
          background-color: pf.$secondaryColor;
          margin: 0px auto 36px;

          &:hover {
            background-color: pf.$buttonHover;
          }
        }
      }

      .image-component img {
        margin-bottom: -10px;
      }

      @media screen and (min-width: 834px) and (max-width: 1199px) {
        .banner-content {
          .banner-text {
            margin: 10px 0px 24px;
          }

          .banner-button {
            margin: 0px 0px 69px;
          }
        }
      }

      @media screen and (min-width: 960px) and (max-width: 1199px) {
        padding: 0px 32.5px;

        .image-component img {
          width: 522px;
        }
      }

      @media screen and (min-width: 1200px) {
        .banner-content {
          .banner-text {
            margin: 28px 0px 20px;
            max-width: 438px;
          }

          .banner-button {
            margin: 0px 0px 132px;
          }
        }
      }
    }
  }

  .partner-how-works-section {
    .steps {
      .default-card .step-counter {
        background-color: pf.$tertiaryColor;
      }
    }
  }

  .our-channels-section.partner-page {
    @media screen and (min-width: 1200px) {
      padding: 68px 0px 65px;
    }
  }

  .partner-logged-area {
    @media screen and (min-width: 1200px) {
      .content-box {
        column-gap: 80px;
      }
    }
  }

  .need-help-section {
    .the-faq-list {
      .panels {
        .panel {
          .v-expansion-panel-title {
            &:hover {
              color: pf.$primaryColor;
            }

            .mdi {
              color: pf.$primaryColor;
            }
          }

          .v-expansion-panel-title--active {
            color: pf.$primaryColor;
          }

          &:hover {
            border-color: pf.$primaryColor;
          }
        }

        .v-expansion-panel--active {
          border-color: pf.$primaryColor !important;
        }
      }
    }

    .talk-button {
      background-color: pf.$secondaryColor;
      color: v.$white;

      &:hover {
        background-color: pf.$buttonHover !important;
      }
    }
  }

  .our-partners-section.partner-page {
    .content .content-sheet .creditors .creditor-block .creditor-logo:hover {
      border-color: pf.$primaryColor;
      box-shadow: 0px 6px 15px pf.$dropShadow !important;
    }
  }
}
</style>
